import { useState } from "react";
import {
  ChevronDown, Menu, X, ArrowRight, ChevronRight, Phone, Mail
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import GoogleTranslate from "./GoogleTranslate";
const Header = () => {
  const [open, setOpen] = useState(false);
  const [mobileOpenDropdown, setMobileOpenDropdown] = useState(null);
  const location = useLocation();
  const navItems = [
    { label: "Home", to: "/" },
    { 
      label: "About", 
      to: "/about",
      subitems: [
        { label: "About Us", to: "/about-us" },
        { label: "Company Branch", to: "/company" },
         { label: "Leadership team", to: "/leadership" },
          { label: "Blog", to: "/blogs" }
      ]
    },
    { 
      label: "Personal Loan", 
      to: "/personal-loan",
      subitems: [ 
        { label: "Personal Loan ", to: "/personal" },
        { label: "Personal Loan Types", to: "/personal-type" },
        { label: "Why CashPro Financial Services Financial", to: "/casprofinanace"}
      ]
    },
    { 
      label: "Home Loan", 
      to: "/home-loan",
      subitems: [
        { label: "Home Loan", to: "/home-loan" },
        { label: "Eligibility Criteria", to: "/eligibility-criteria" },
        { label: "Documents Required", to: "/documents" }
      ]
    },
    { 
      label: "Business Loan", 
      to: "/business-loan",
      subitems: [
        { label: "Business Loan", to: "/business" },
        { label: "Eligibility Criteria", to: "/eligibility" },
        { label: "Type of Business Loan", to: "/typeofbusinessLoan" }
      ]
    },
    { 
      label: "Car Refinance", 
      to: "/car-refinance",
      subitems: [
        { label: "Loan Against Car", to: "/loan-againstcar" },
        { label: "Car Loan Balance Transfer + Topup", to: "/carloan-Balance" },
        { label: "Refinance Purchase", to: "/refinance" }
      ]
    },
    { label: "Project Loan", to: "/project-loan" },
    { label: "MSME Loan service", to: "/msme-loan" },
    { label: "FAQ", to: "/faq" },
    { label: "Contact", to: "/contact" }
  ];
  const toggleMobileDropdown = (label) => {
    setMobileOpenDropdown(mobileOpenDropdown === label ? null : label);
  };
  return (
    <header className="sticky top-0 z-[100]">
      <div className="bg-gradient-to-r from-green-700 via-green-600 to-emerald-700 text-white shadow-md border-b border-yellow-300/30">
        <div className="max-w-7xl mx-auto px-3 py-2 sm:px-4 sm:py-2">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:justify-between">
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
              <a
                href="tel:+918887141052"
                className="flex items-center gap-1.5 hover:text-yellow-200 transition-all duration-300 hover:scale-105 group"
              >
                <Phone size={14} className="text-yellow-300 group-hover:animate-pulse" />
                <span className="text-xs sm:text-sm font-medium">Call: +91 88871 41052</span>
              </a>
              <span className="text-white/30 hidden sm:inline">|</span>
              <a
                href="mailto:info@cashpro.co.in"
                className="flex items-center gap-1.5 hover:text-yellow-200 transition-all duration-300 hover:scale-105 group"
              >
                <Mail size={14} className="text-yellow-300 group-hover:animate-pulse" />
                <span className="text-xs sm:text-sm font-medium">info@cashpro.co.in</span>
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
              <div className="relative flex items-center bg-white/10 backdrop-blur-sm rounded-full px-2 py-0.5 border border-white/20 hover:bg-white/20 transition-all duration-300">
                 <GoogleTranslate />
              </div>
              <span className="text-white/30 hidden sm:inline">|</span>
              <div className="flex items-center gap-2">
                <a
                  href="https://www.facebook.com/profile.php?id=61582287655006"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-yellow-300 transition-all duration-300 hover:scale-110"
                >
                  <FaFacebook size={14} />
                </a>
                <a
                  href="https://www.linkedin.com/in/cashprodistributionservices/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-yellow-300 transition-all duration-300 hover:scale-110"
                >
                  <FaLinkedin size={14} />
                </a>
                <a
                  href="https://www.instagram.com/cashpro_financial_services/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-yellow-300 transition-all duration-300 hover:scale-110"
                >
                  <FaInstagram size={14} />
                </a>
                <a
                  href="https://www.youtube.com/@CashProFinancialServices"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-yellow-300 transition-all duration-300 hover:scale-110"
                >
                  <FaYoutube size={14} />
                </a>
              </div>
              <span className="text-white/30 hidden sm:inline">|</span>
              <Link
                to="/business-partner"
                className="relative px-3 py-1 rounded-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 text-xs sm:text-sm font-medium transition-all duration-300 hover:scale-105 shadow-sm"
              >
                Business Partner
                <span className="absolute -top-1 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white animate-pulse">
                  N
                </span>
              </Link>
              <Link
                to="/associate-program"
                className="px-3 py-1 rounded-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 text-xs sm:text-sm font-medium transition-all duration-300 hover:scale-105 shadow-sm"
              >
                Associate
              </Link>
              <Link
                to="/appointment"
                className="bg-yellow-400 hover:bg-red-500 text-gray-800 hover:text-white font-semibold px-3 py-1 rounded-full shadow-sm transition-all duration-300 flex items-center gap-1 text-xs sm:text-sm group hover:scale-105"
              >
                Appointment
                <ChevronRight size={14} className="group-hover:translate-x-0.5 transition-transform duration-300" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white shadow-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <img
              src="/logo.png"
              alt="CashPro"
              className="h-8 sm:h-10 lg:h-11 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>
          <nav className="hidden lg:flex items-center gap-4 xl:gap-6 font-medium">
            {navItems.map((item) => {
              if (item.subitems && item.subitems.length > 0) {
                return (
                  <div key={item.label} className="relative group">
                    <button className="flex items-center gap-1 text-gray-700 hover:text-green-600 transition-all duration-300 py-4 group-hover:scale-105 text-sm">
                      {item.label}
                      <ChevronDown size={12} className="group-hover:rotate-180 transition-transform duration-300" />
                    </button>
                    <div className="absolute top-full left-0 w-56 bg-white rounded-xl shadow-xl 
                          opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 
                          border border-gray-100 overflow-hidden z-20">
                      <div className="py-1">
                        {item.subitems.map((sub) => (
                          <Link
                            key={sub.label}
                            to={sub.to}
                            className="flex items-center justify-between px-4 py-2 hover:bg-yellow-50 text-sm font-medium text-gray-700 hover:text-green-600 transition-colors duration-200"
                          >
                            {sub.label}
                            <ArrowRight size={12} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              }
              return (
                <Link
                  key={item.label}
                  to={item.to}
                  className={`text-gray-700 hover:text-green-600 transition-all duration-300 hover:scale-105 text-sm ${
                    location.pathname === item.to ? 'text-green-700 font-bold border-b-2 border-yellow-400' : ''
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
          <Link
            to="/contact"
            className="hidden lg:inline-flex items-center justify-center px-4 py-1.5 rounded-lg font-bold text-white text-sm
              bg-green-600 hover:bg-green-700 transition-all duration-300 shadow-md hover:shadow-lg active:scale-95 hover:scale-105"
          >
            Get Loan
          </Link>
          <button
            className="lg:hidden p-1.5 text-green-700 bg-gray-100 rounded-lg hover:bg-yellow-100 transition-all duration-300 hover:scale-105"
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ${
            open ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="px-4 py-4 bg-white shadow-lg border-t border-gray-100">
            {navItems.map((item) => {
              if (item.subitems && item.subitems.length > 0) {
                return (
                  <div key={item.label} className="py-1">
                    <button
                      onClick={() => toggleMobileDropdown(item.label)}
                      className="flex items-center justify-between w-full py-2 text-base font-bold text-gray-800 border-b border-gray-50 hover:text-green-600 transition-colors"
                    >
                      {item.label}
                      <ChevronDown
                        size={18}
                        className={`transition-transform duration-300 ${
                          mobileOpenDropdown === item.label ? 'rotate-180' : ''
                        }`}
                      />
                    </button>
                    <div
                      className={`mt-1 space-y-1 overflow-hidden transition-all duration-300 ${
                        mobileOpenDropdown === item.label ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                      }`}
                    >
                      {item.subitems.map((sub) => (
                        <Link
                          key={sub.label}
                          to={sub.to}
                          onClick={() => setOpen(false)}
                          className="block py-2 px-3 text-gray-600 font-medium hover:bg-yellow-50 rounded-lg text-sm"
                        >
                          {sub.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                );
              }
              return (
                <Link
                  key={item.label}
                  to={item.to}
                  className="block py-2 text-base font-bold text-gray-800 border-b border-gray-50 hover:text-green-600 transition-colors"
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </Link>
              );
            })}
            <div className="pt-4">
              <Link
                to="/contact"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center w-full py-2 rounded-lg text-white font-bold bg-green-600 hover:bg-green-700 transition-all duration-300 hover:scale-105 text-sm"
              >
                Get Loan Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
